import React from 'react';
import Thumbnail from './Thumbnail';
import { EntityType } from '@constants/attachments';

const ResourceThumbnail = ({
  resourceId,
  resourceName = '',
  size = 'medium',
  className = '',
  hideEmpty = false,
  thumbnailSize
}) => {
  return (
    <Thumbnail
      entityType={EntityType.RESOURCE}
      entityId={resourceId}
      entityName={resourceName}
      size={size}
      fallbackIcon="📷"
      className={className}
      hideEmpty={hideEmpty}
      thumbnailSize={thumbnailSize}
    />
  );
};

export default ResourceThumbnail;
